import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import ProfitCalculator from 'src/app/organisms/Homepage/ProfitCalculator/ProfitCalculator';

const Calculator = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
  >
    <ProfitCalculator />
  </SectionLayout>
);

export default Calculator;
